export const CONSENT_ITEM_TITLE_FIELD = 'ItemTitle';
export const CONSENT_ITEM_DESCRIPTION_FIELD = 'ItemDescription';
export const CONSENT_STEP_TITLE = 'consent';
